import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { BsWhatsapp } from "react-icons/bs";
import { SlSocialFacebook } from "react-icons/sl";
import { BsTwitterX } from "react-icons/bs";
import { SlSocialLinkedin } from "react-icons/sl";
import { GrMailOption } from "react-icons/gr";
import { SiGmail } from "react-icons/si";
import { ApiLocalUrl } from "../../Const";
import { RECheck, RECopy } from "../icons/IconSvg";
export default function SocialShareModal({ type , data, onHide }) {
    const [copyIcon, setCopyIcon] = useState(false);

    const handleCpoy = async () => {
        await navigator.clipboard.writeText(`${ApiLocalUrl}${type}/${data?.data}`);
        setCopyIcon(true);
        setTimeout(() => {
            setCopyIcon(false);
        }, 2000);
    };

    return (
        <Modal size="md" aria-labelledby="contained-modal-title-vcenter" className="modal-details" show={data.show} centered>
            <Modal.Header className="justify-content-between">
                <Modal.Title>Share this Property</Modal.Title>
                <button type="button" onClick={onHide} className="close-icon-style">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="share_body">
                    <a href={`https://web.whatsapp.com/send?text=${ApiLocalUrl}${type}/${data?.data}`} target="_blank" rel="noreferrer">
                        <BsWhatsapp />
                    </a>
                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${ApiLocalUrl}${type}/${data?.data}`} target="_blank" rel="noreferrer">
                        <SlSocialFacebook />
                    </a>
                    <a href={`http://twitter.com/share?url=${ApiLocalUrl}${type}/${data?.data}`} target="_blank" rel="noreferrer">
                        <BsTwitterX />
                    </a>
                    <a href={`https://www.linkedin.com/cws/share?url=${ApiLocalUrl}${type}/${data?.data}`} target="_blank" rel="noreferrer">
                        <SlSocialLinkedin />
                    </a>
                    <a href={`https://mail.google.com/mail/u/0/?view=cm&fs=1&to=&su=${data?.name}&body=${ApiLocalUrl}${type}/${data?.data}`} target="_blank" rel="noreferrer">
                        <SiGmail />
                    </a>
                    <a href={`mailto:?subject=${encodeURIComponent(data?.name)}&body=${encodeURIComponent(ApiLocalUrl + `/${type}/` + data?.data)}`} target="_blank" rel="noreferrer">
                        <GrMailOption />
                    </a>
                </div>
                <div className="share_link">
                    <input type="text" value={`${ApiLocalUrl}${type}/${data?.data}`} readOnly className="custom-input" />
                    {copyIcon ? (
                        <button type="button">
                            <RECheck />
                        </button>
                    ) : (
                        <button type="button" onClick={handleCpoy}>
                            <RECopy />
                        </button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
}
